<template>
    <!-- Sidebar -->
    <div id="sidebar-wrapper">
        <ul class="sidebar-nav nav-pills nav-stacked" id="menu">
            <template v-for="(menuData, index) in $store.getters.menuArr">
                <li v-bind:key="index" :id="menuData.slug" :class="'menuCommon '+menuData.slug">
                    <template v-if="menuData.is_view_allow == 1">
                        <template v-if="menuData.sub_menu == '' || menuData.sub_menu == null || menuData.sub_menu_view_count != 1">
                            <template v-if="menuData.url != null && menuData.url != '' && menuData.is_view_allow == 1">
                                <template v-if="menuData.menu_title.length >= 18">
                                    <a :href="menuData.url" target="_blank" v-b-tooltip.hover :title="menuData.menu_title">
                                        <span :class="'spm-nav-menu sidebar-menu-icon ' + menuData.icon_url"></span>
                                        {{stringTrim(menuData.menu_title,18)}}
                                    </a>
                                </template>
                                <template v-else>
                                    <a :href="menuData.url" target="_blank">
                                        <span :class="'spm-nav-menu sidebar-menu-icon ' + menuData.icon_url"></span>
                                        {{menuData.menu_title}}
                                    </a>
                                </template>
                            </template>
                            <template v-else-if="menuData.features.length == 1 && (menuData.features[0].name == 'Iframe URL' || menuData.features[0].id == 4) && menuData.iframe_url_arr.length > 0">
                                <!-- Redirect to New Tab When Single Iframe Is Assigned -->
                                <template v-if="menuData.iframe_url_arr.length == 1">
                                    <template v-for="(iframeURL, menuIframeIndex) in menuData.iframe_url_arr">
                                        <template v-if="iframeURL != null && iframeURL != ''">
                                            <template v-if="menuData.menu_title.length >= 18">
                                                <div class="menu-wrapper" :key="menuIframeIndex">
                                                    <a :href="iframeURL" target="_blank" v-b-tooltip.hover :title="menuData.menu_title">
                                                        <span :class="'spm-nav-menu sidebar-menu-icon ' + menuData.icon_url">
                                                        </span>
                                                        {{stringTrim(menuData.menu_title,18)}}
                                                    </a>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="menu-wrapper" :key="menuIframeIndex">
                                                    <a :href="iframeURL" target="_blank" v-b-tooltip.hover :title="menuData.menu_title">
                                                        <span :class="'spm-nav-menu sidebar-menu-icon ' + menuData.icon_url">
                                                        </span>
                                                        {{menuData.menu_title}}
                                                    </a>
                                                </div>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                                <!-- When Multiple Iframes Are Assigned, Display A Common Page And Autoload More Than 1 Iframe -->
                                <template v-else>
                                    <template v-if="menuData.menu_title.length >= 18">
                                        <div class="menu-wrapper">
                                            <router-link v-b-tooltip.hover :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                                <span :class="'spm-nav-menu sidebar-menu-icon ' + menuData.icon_url">
                                                </span>{{stringTrim(menuData.menu_title,18)}}
                                            </router-link>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="menu-wrapper">
                                            <router-link v-b-tooltip.hover :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                                <span :class="'spm-nav-menu sidebar-menu-icon ' + menuData.icon_url">
                                                </span>{{menuData.menu_title}}
                                            </router-link>
                                        </div>
                                    </template>
                                </template>
                            </template>
                            <template v-else>
                                <template v-if="menuData.menu_title.length >= 18">
                                    <router-link v-b-tooltip.hover :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                        <span :class="'spm-nav-menu sidebar-menu-icon ' + menuData.icon_url"></span>
                                        {{stringTrim(menuData.menu_title,18)}}
                                    </router-link>
                                </template>
                                <template v-else>
                                    <router-link v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                        <span :class="'spm-nav-menu sidebar-menu-icon ' + menuData.icon_url"></span>
                                        {{menuData.menu_title}}
                                    </router-link>
                                </template>
                            </template>
                        </template>
                        <template v-else>
                            <template v-if="menuData.url != null && menuData.url != ''">
                                <template v-if="menuData.menu_title.length >= 18">
                                    <div class="menu-wrapper">
                                        <i class="fa fa-angle-down menu-arrow" aria-hidden="true"></i>
                                        <a v-b-tooltip.hover :title="menuData.menu_title" :href="menuData.url" target="_blank">
                                            <label class="tree-toggle nav-header">
                                                <span :class="'spm-nav-menu sidebar-menu-icon ' + menuData.icon_url"></span>
                                                {{stringTrim(menuData.menu_title,18)}}
                                            </label>
                                        </a>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="menu-wrapper">
                                        <i class="fa fa-angle-down menu-arrow" aria-hidden="true"></i>
                                        <a v-b-tooltip.hover :title="menuData.menu_title" :href="menuData.url" target="_blank">
                                            <label class="tree-toggle nav-header">
                                                <span :class="'spm-nav-menu sidebar-menu-icon ' + menuData.icon_url"></span>
                                                {{menuData.menu_title}}
                                            </label>
                                        </a>
                                    </div>
                                </template>
                            </template>
                            <template v-else-if="menuData.features.length == 1 && (menuData.features[0].name == 'Iframe URL' || menuData.features[0].id == 4) && menuData.iframe_url_arr.length > 0">
                                <!-- Redirect to New Tab When Single Iframe Is Assigned -->
                                <template v-if="menuData.iframe_url_arr.length == 1">
                                    <template v-for="(iframeURL, menuIframeIndex) in menuData.iframe_url_arr">
                                        <template v-if="iframeURL != null && iframeURL != ''">
                                            <template v-if="menuData.menu_title.length >= 18">
                                                <div class="menu-wrapper" :key="menuIframeIndex">
                                                    <i class="fa fa-angle-down menu-arrow" aria-hidden="true"></i>
                                                    <a v-b-tooltip.hover :title="menuData.menu_title" :href="iframeURL" target="_blank">
                                                        <label class="tree-toggle nav-header">
                                                            <span :class="'spm-nav-menu sidebar-menu-icon ' + menuData.icon_url">
                                                            </span> {{stringTrim(menuData.menu_title,18)}}
                                                        </label>
                                                    </a>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="menu-wrapper" :key="menuIframeIndex">
                                                    <i class="fa fa-angle-down menu-arrow" aria-hidden="true"></i>
                                                    <a v-b-tooltip.hover :title="menuData.menu_title" :href="iframeURL" target="_blank">
                                                        <label class="tree-toggle nav-header">
                                                            <span :class="'spm-nav-menu sidebar-menu-icon ' + menuData.icon_url">
                                                            </span> {{menuData.menu_title}}
                                                        </label>
                                                    </a>
                                                </div>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                                <!-- When Multiple Iframes Are Assigned, Display A Common Page And Autoload More Than 1 Iframe -->
                                <template v-else>
                                    <template v-if="menuData.menu_title.length >= 18">
                                        <div class="menu-wrapper">
                                            <i class="fa fa-angle-down menu-arrow" aria-hidden="true"></i>
                                            <router-link v-b-tooltip.hover :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                                <label class="tree-toggle nav-header">
                                                    <span :class="'spm-nav-menu sidebar-menu-icon ' + menuData.icon_url">
                                                    </span> {{stringTrim(menuData.menu_title,18)}}
                                                </label>
                                            </router-link>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="menu-wrapper">
                                            <i class="fa fa-angle-down menu-arrow" aria-hidden="true"></i>
                                            <router-link v-b-tooltip.hover :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                                <label class="tree-toggle nav-header">
                                                    <span :class="'spm-nav-menu sidebar-menu-icon ' + menuData.icon_url">
                                                    </span> {{menuData.menu_title}}
                                                </label>
                                            </router-link>
                                        </div>
                                    </template>
                                </template>
                            </template>
                            <template v-else>
                                <template v-if="menuData.menu_title.length >= 18">
                                    <div class="menu-wrapper">
                                        <i class="fa fa-angle-down menu-arrow" aria-hidden="true"></i>
                                        <router-link v-b-tooltip.hover :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                            <label class="tree-toggle nav-header">
                                                <span :class="'spm-nav-menu sidebar-menu-icon ' + menuData.icon_url"></span>
                                                {{stringTrim(menuData.menu_title,18)}}
                                            </label>
                                        </router-link>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="menu-wrapper">
                                        <i class="fa fa-angle-down menu-arrow" aria-hidden="true"></i>
                                        <router-link v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                            <label class="tree-toggle nav-header">
                                                <span :class="'spm-nav-menu sidebar-menu-icon ' + menuData.icon_url"></span>
                                                {{menuData.menu_title}}
                                            </label>
                                        </router-link>
                                    </div>
                                </template>
                            </template>
                            <ul class="nav nav-list tree">
                                <template v-for="(subMenuData, index1) in menuData.sub_menu">
                                    <template v-if="subMenuData.is_view_allow == 1">
                                        <template v-if="subMenuData.url != null && subMenuData.url != '' && subMenuData.is_view_allow == 1">
                                            <li :key="index1" :class="'subMenuLi '+subMenuData.slug">
                                                <template v-if="subMenuData.menu_title.length >= 30">
                                                    <a v-b-tooltip.hover :title="subMenuData.menu_title" :href="subMenuData.url" target="_blank">
                                                        {{stringTrim(subMenuData.menu_title,30)}}
                                                    </a>
                                                </template>
                                                <template v-else>
                                                    <a :href="subMenuData.url" target="_blank">
                                                        {{subMenuData.menu_title}}
                                                    </a>
                                                </template>
                                            </li>
                                        </template>
                                        <template v-else-if="subMenuData.features.length == 1 && (subMenuData.features[0].name == 'Iframe URL' || subMenuData.features[0].id == 4) && subMenuData.iframe_url_arr.length > 0">
                                            <!-- Redirect to New Tab When Single Iframe Is Assigned -->
                                            <template v-if="subMenuData.iframe_url_arr.length == 1">
                                                <template v-for="(submenuIframeURL, submenuIframeIndex) in subMenuData.iframe_url_arr">
                                                    <template v-if="submenuIframeURL != null && submenuIframeURL != ''">
                                                        <li :class="'subMenuLi '+subMenuData.slug">
                                                            <template v-if="subMenuData.menu_title.length >= 18">
                                                                <a v-b-tooltip.hover :title="subMenuData.menu_title" :href="submenuIframeURL" target="_blank">
                                                                    {{stringTrim(subMenuData.menu_title,18)}}
                                                                </a>
                                                            </template>
                                                            <template v-else>
                                                                <a v-b-tooltip.hover :title="subMenuData.menu_title" :href="submenuIframeURL" target="_blank">
                                                                    {{subMenuData.menu_title}}
                                                                </a>
                                                            </template>
                                                        </li>
                                                    </template>
                                                </template>
                                            </template>
                                            <!-- When Multiple Iframes Are Assigned, Display A Common Page And Autoload More Than 1 Iframe -->
                                            <template v-else>
                                                <li :key="index1" :class="'subMenuLi '+subMenuData.slug">
                                                    <template v-if="subMenuData.menu_title.length >= 18">
                                                        <router-link v-b-tooltip.hover :title="subMenuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:subMenuData.slug}}">
                                                            {{stringTrim(subMenuData.menu_title,18)}}
                                                        </router-link>
                                                    </template>
                                                    <template v-else>
                                                        <router-link v-b-tooltip.hover :title="subMenuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:subMenuData.slug}}">
                                                            {{subMenuData.menu_title}}
                                                        </router-link>
                                                    </template>
                                                </li>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <li :key="index1" :class="'subMenuLi '+subMenuData.slug">
                                                <template v-if="subMenuData.menu_title.length >= 30">
                                                    <router-link v-b-tooltip.hover :title="subMenuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:subMenuData.slug}}">
                                                        {{stringTrim(subMenuData.menu_title,30)}}
                                                    </router-link>
                                                </template>
                                                <template v-else>
                                                    <router-link v-bind:to="{name: 'CommonPage', params:{type:subMenuData.slug}}">
                                                        {{subMenuData.menu_title}}
                                                    </router-link>
                                                </template>
                                            </li>
                                        </template>
                                    </template>
                                </template>
                            </ul>
                        </template>
                    </template>
                </li>
                <!-- <li>
                    <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left"> <i class="fa fa-map-marker fa-stack-1x "></i></span> Sales Programs <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                    <ul class="nav nav-list tree">
                        <li>Standard Operating Procedures</li>
                        <li>Marketing Materials</li>
                        <li>Warranty</li>
                        <li>Certification</li>
                        <li>Sales Meetings</li>
                        <li><a href="/colorchart">Color Chart</a></li>
                        <li><a href="#">Buttons</a></li>
                    </ul>
                </li> -->
            </template>
            <li>
                <label class="tree-toggle nav-header">
                    <span class="spm-nav-menu sidebar-menu-icon icon-forms"></span>
                    Forms <i class="fa fa-angle-down  menu-arrow" aria-hidden="true"></i>
                </label>
                <ul class="nav nav-list tree">
                    
                    <!-- Dispute/Chargeback Request Form -->
                    <li id="DisputeChargebackRequestForm">
                        <!-- <router-link v-bind:to="{name: 'ListDisputeChargebackRequest'}"> -->
                            <a :href="disputeChargeBackIframeURL" target="_blank" v-b-tooltip.hover title="Dispute/Chargeback Request Form">
                                Dispute/Chargeback Request Form
                            </a>
                        <!-- </router-link> -->
                    </li>

                    <!-- Dayforce Time Edit Request -->
                    <li id="DayforceTimeEditRequestForm">
                        <a :href="dayforceTimeEditIframeURL" target="_blank" v-b-tooltip.hover title="Dayforce Time Edit Request">
                            Dayforce Time Edit Request
                        </a>
                    </li>

                    <template v-if="loginUserRoleId == 1 || loginUserRoleId == 2">
                        <!-- <li id="ROReversalRequest">
                            <router-link v-bind:to="{name: 'ListROReversalRequest'}">
                                RO Reversal Request
                            </router-link>
                        </li>
                        <li id="TechTimeForm">
                            <router-link v-bind:to="{name: 'ListTechTime'}">
                                Tech Time
                            </router-link>
                        </li> -->
                        <!-- <li id="DayforceTimeRequest">
                            <router-link v-bind:to="{name: 'ListDayforaceTimeEditRequest'}">
                                Dayforce Time Edit Request
                            </router-link>
                        </li> -->
                        <!-- <li id="DayforceTimeRequestSpanish">
                            <router-link v-b-tooltip.hover title="Dayforce Time Edit Request (Spanish)" v-bind:to="{name: 'ListSpanishDayforaceTimeEditRequest'}"> -->
                                <!-- Technician Time Edit Request (Spanish) -->
                                <!-- {{stringTrim("Dayforce Time Edit Request (Spanish)", 30)}}
                            </router-link>
                        </li> -->
                        <!-- <li id="OfficeSuppliesForm">
                            <router-link v-bind:to="{name: 'ListOfficeSupplier'}">
                                Office Supplies Order
                            </router-link>
                        </li>
                        <li id="WareHouseOrderSupplies">
                            <router-link v-bind:to="{name: 'ListWareHouseOrderSupplies'}">
                               Warehouse Supplies Order
                            </router-link>
                        </li> -->
                        <li id="UniformRequestForm">
                            <router-link v-bind:to="{name: 'ListUniformRequestForm'}">
                                Uniform Request
                            </router-link>
                        </li>
                    </template>
                    <template v-else>
                        <!-- <li id="ROReversalRequest">
                            <router-link v-bind:to="{name: 'AddUpdateROReversalRequest'}">
                                RO Reversal Request
                            </router-link>
                        </li>
                        <li id="TechTimeForm">
                            <router-link v-bind:to="{name: 'AddUpdateTechTime'}">
                                Tech Time
                            </router-link>
                        </li> -->
                        <!-- <li id="DayforceTimeRequest">
                            <router-link v-bind:to="{name: 'AddUpdateDayforaceTimeEditRequest'}">
                                Dayforce Time Edit Request
                            </router-link>
                        </li> -->
                        <!-- <li id="DayforceTimeRequestSpanish">
                            <router-link v-b-tooltip.hover title="Dayforce Time Edit Request (Spanish)" v-bind:to="{name: 'AddUpdateSpanishDayforaceTimeEditRequest'}">
                                {{stringTrim("Dayforce Time Edit Request (Spanish)", 30)}}
                            </router-link>
                        </li> -->
                        <!-- <li id="OfficeSuppliesForm">
                            <router-link v-bind:to="{name: 'AddUpdateOfficeSupplier'}">
                                Office Supplies Order
                            </router-link>
                        </li>
                        <li id="OfficeSuppliesForm">
                            <router-link v-bind:to="{name: 'AddUpdateWarehouseOrderSupplies'}">
                                Warehouse Supplies Order
                            </router-link>
                        </li> -->
                        <li id="UniformRequestForm">
                            <router-link v-bind:to="{name: 'AddUpdateUniformRequestForm'}">
                                Uniform Request
                            </router-link>
                        </li>
                    </template>
                    <li id="OfficeSuppliesForm">
                        <router-link v-bind:to="{name: 'ListOfficeSupplier'}">
                            Office Supplies Order
                        </router-link>
                    </li>
                    <li id="WareHouseOrderSupplies">
                        <router-link v-bind:to="{name: 'ListWareHouseOrderSupplies'}">
                            Warehouse Supplies Order
                        </router-link>
                    </li>
                    <li id="RestockingFee">
                        <router-link v-bind:to="{name: 'ListRestockingFee'}">
                            Restocking Fee
                        </router-link>
                    </li>
                    <template v-if="permissionsArray.includes('access_vendor_request_form')">
                        <li id="ListVendor">
                            <router-link v-bind:to="{name: 'ListVendor'}">
                                Vendor
                            </router-link>
                        </li>
                    </template>
                    <template v-if="permissionsArray.includes('access_form_email_manager')">
                        <li id="ListFormEmailManager">
                            <router-link v-bind:to="{name: 'ListFormEmailManager'}">
                                Form Email Manager
                            </router-link>
                        </li>
                    </template>
                    <!--
                        Date: 29th Feb, 2024
                        Reason: Added the PAR Request Iframe URL and deactivate/move PAR Form to the "Archived" section
                        parRequestFormIframeURL : 'https://app.smartsheet.com/b/form/117976c482d54164bf240523e7e8ab5d',
                    -->
                    <li id="PARRequest">
                        <!-- <router-link v-bind:to="{name: 'ListPARRequest'}"> -->
                        <a :href="parRequestFormIframeURL" target="_blank" v-b-tooltip.hover title="PAR Request">
                            PAR Request
                        </a>
                        <!-- </router-link> -->
                    </li>

                    <!-- Travel Request Form -->
                    <li id="TravelRequestForm">
                        <router-link v-bind:to="{name: 'ListTravelRequest'}">
                            Travel Request Form
                        </router-link>
                    </li>

                    <!-- <li id="FlowerRequestForm">
                        <a href="https://forms.office.com/r/F7j7bunkdk" target="_blank">
                            Flower Request Form
                        </a>
                    </li> -->

                    <!-- Supplies Order Form -->
                    <li id="suppliesOrderRequestForm">
                        <a :href="suppliesOrderIframeURL" target="_blank" v-b-tooltip.hover title="Supplies Order Form">
                            Supplies Order Form
                        </a>
                    </li>
                </ul>
            </li>
            <template v-if="permissionsArray.includes('can_view_parts_sales_menu')">
                <li id="ListUploadPartsSales" class="menuCommon parts-sales">
                    <label class="tree-toggle nav-header">
                        <span class="spm-nav-menu sidebar-menu-icon icon-parts-sales"></span>
                        <router-link v-bind:to="{name: 'ListUploadPartsSales'}">
                            Parts Sales
                        </router-link>
                    </label>
                </li>
            </template>
            <template v-if="loginUserRoleId == 1 || loginUserRoleId == 2">
                <li class="menuCommon">
                    <label class="tree-toggle nav-header">
                        <span class="spm-nav-menu sidebar-menu-icon icon-archives">    
                        </span>
                        Archived <i class="fa fa-angle-down  menu-arrow" aria-hidden="true"></i>
                    </label>
                    <ul class="nav nav-list tree">
                        <li id="DayforceTimeRequest">
                            <router-link v-bind:to="{name: 'ListDayforaceTimeEditRequest'}">
                                Dayforce Time Edit Request
                            </router-link>
                        </li>
                        <li id="DayforceTimeRequestSpanish">
                            <router-link v-b-tooltip.hover title="Dayforce Time Edit Request (Spanish)" v-bind:to="{name: 'ListSpanishDayforaceTimeEditRequest'}">
                                {{stringTrim("Dayforce Time Edit Request (Spanish)", 30)}}
                            </router-link>
                        </li>
                        <!--
                            Date: 29th Feb, 2024
                            Reason: Deactivate/move PAR Form to the "Archived" section
                        -->
                        <li id="PARRequest">
                            <router-link v-bind:to="{name: 'ListPARRequest'}">
                                PAR Request
                            </router-link>
                        </li>
                    </ul>
                </li>
            </template>
        </ul>
    </div>
<!-- Sidebar -->
</template>

<script>
    import Vue from 'vue';
    import {HTTP} from '../../http-common.js';
    import EventBus from '.././event-bus';
    var self;

    import {commonMixins} from '../../mixins/commonMixins';

    export default {
        name: 'Center',
        mixins: [commonMixins],
        data() {
            return {
                menuArr: [],
                loginUserRoleId: 1,
                loginUsername: 9999999,
                permissionsArray: ['access_vendor_request_form'],
                disputeChargeBackIframeURL : 'https://app.smartsheet.com/b/form/f091f8fafae34414923456a7f6012082',
                suppliesOrderIframeURL : 'https://app.smartsheet.com/b/form/aeaec52f0b584c77bd5f2e43a8559405',
                dayforceTimeEditIframeURL : 'https://app.smartsheet.com/b/form/83a016bc11c1417daa72ce7f07100062',
                parRequestFormIframeURL : 'https://app.smartsheet.com/b/form/117976c482d54164bf240523e7e8ab5d'
            }
        },
        beforeMount: function () {
        },
        mounted: function () {
            self = this;
            $("#menu-toggle").click(function (e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled");
            });
            $("#menu-toggle-2").click(function (e) {
                //console.log("here");
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled-2");
                $('#menu ul').hide();
            });

            $('.tree-toggle').click(function () {
                $(this).parent().children('ul.tree').toggle(200);
            });
            $('.menu-arrow').click(function () {
                $(this).parent().children('ul.tree').toggle(200);
            });

            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                // self.loginUserRoleId = userJson['role'].system_id;
                self.loginUsername = userJson['username'];
                self.$store.dispatch('loadMenu');
            }
        },
        methods: {
        }
    };
    EventBus.$on('user-role', function (roleId) {
        if (typeof (self) != 'undefined') {
            self.loginUserRoleId = roleId;
        }
    });
    EventBus.$on('reload-menu', function (menuArr) {
        //console.log('Event Called');
        if (typeof (self) != 'undefined') {
            self.$nextTick(() => {
                self.firstLoadMenu();
            });
        }
    });
    EventBus.$on("permissions", function(isLogin, permissionArray) {
        if (typeof self != "undefined") {
            self.permissionsArray = [];
            if(permissionArray && permissionArray.length > 0) {
                for (var i = 0; i < permissionArray.length; i++) {
                    self.permissionsArray.push(permissionArray[i].name);
                }
            }
        }
    });
</script>
<style scoped>
.sidebar-menu-icon {
    height: 28px;
    width: 34px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.sidebar-nav li .menu-wrapper i:hover + a label .sidebar-menu-icon{
    color: #fff;
}
.menuCommon.active i,
.menuCommon.active a,
.menuCommon.active a label,
.menuCommon.active a span 
{
    color: #fff;
    background-color: #098de1;
}
.subMenuLi a {
    color: #4d646f;
}
.nav.nav-list.tree li a {
    background: transparent !important;
}
</style>
